import { Box, styled } from "@mui/material";

interface IFlexBoxProps {
    direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
    alignItems?: string;
    justifyContent?: string;
}

const FlexBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'direction' && prop !== 'alignItems' && prop !== 'justifyContent',
})<IFlexBoxProps>(
    ({ direction = "column", alignItems = "stretch", justifyContent = "flex-start" }) => ({
        display: "flex",
        flexDirection: direction,
        alignItems,
        justifyContent,
    })
);

export default FlexBox;
